module.exports = __webpack_public_path__ + "img/lang-zh.722b564b.png";